// Shared wrapper that the entities all use.
// Mostly concerned with the base styles and layout.
import React from 'react';

import { cn } from '../../lib/utils';

const EntityWrapper = React.forwardRef(({ children, className, jumbo = false, suggestion = false, truncated = false, ...props }, ref) => (
  <entity
    {...props}
    ref={ref}
    className={cn(
      'inline-flex min-w-0',
      truncated && 'max-w-prose',
      jumbo ? 'entity-jumbo items-center gap-2 align-middle' : 'items-baseline gap-1',
      suggestion && 'pointer-events-none gap-2',
      className,
    )}
  >
    {children}
  </entity>
));
EntityWrapper.displayName = 'EntityWrapper';

export default EntityWrapper;
